import { Card, Divider, IconButton, Modal, Stack, TextField, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { AddIcon, BackIcon, CloseIcon, EditIcon, EditIcon2, SearchIcon, SendIcon } from '../../../Components/Icons/Icons';
import { AppColors } from '../../../Utils/helper/AppColors';
import IconContainer from '../../../Components/IconContainer';
import moment from 'moment';
import _ from 'lodash';
import { Select, theme } from 'antd';
import { getColorSettings } from '../../../Utils/helper/commonUtils';

const style = {
	position: 'absolute',
	top: '50%',
	left: '50%',
	transform: 'translate(-50%, -50%)',
	bgcolor: AppColors.WHITE,
	borderRadius: '8px',
};

const dummyCampaigns = [
	{ _id: '1', basicDetails: { name: 'Campaign Alpha' } },
	{ _id: '2', basicDetails: { name: 'Campaign Beta' } },
	{ _id: '3', basicDetails: { name: 'Campaign Gamma' } },
];

export default function NotesColumn({ comments, campaign, handleAddComment, id, firstIcon = false }) {
	const [show, setShow] = useState(false);
	const [text, setText] = useState('');
	const [selectedCampaign, setSelectedCampaign] = useState(null);

	const handleSelectCampaign = (value, option) => {
		setSelectedCampaign(value);
	};

	const handleSend = () => {
		handleAddComment({ payload: { text, compaignUserId: id }, onComplete: () => setText('') });
	};

	comments = comments?.sort((a, b) => {
		return new Date(b?.createdAt) - new Date(a?.createdAt);
	});

	const localSettingColors = getColorSettings();

	return (
		<Stack>
			{firstIcon ? (
				<EditIcon2 cursor="pointer" onClick={() => setShow(true)} color={localSettingColors.fontColor} size={18} />
			) : (
				<EditIcon cursor="pointer" onClick={() => setShow(true)} color={localSettingColors.fontColor} size={18} />
			)}
			<Modal anchor="right" open={show} onClose={() => setShow(false)}>
				<Stack height="calc(100vh - 120px)" width={500} sx={style}>
					<Stack p={2} psx direction="row" alignItems="center" justifyContent="space-between">
						<Typography
							sx={{ fontSize: 24, fontFamily: 'Poppins', color: AppColors.HEADING_TITLE, fontWeight: 600, lineHeight: '130%' }}
						>
							Notes
						</Typography>
						<IconButton onClick={() => setShow(false)} size="small">
							<CloseIcon />
						</IconButton>
					</Stack>

					<Divider />

					<Stack height="100%" overflow="auto" sx={{ paddingTop: 3 }}>
						<Stack height="100%" overflow="auto" sx={{ paddingX: 2, gap: 2 }}>
							{comments?.map((comment, idx) => (
								<Stack
									key={comment?._id}
									gap={0.5}
									sx={{
										//  border: '1px solid red',
										borderRadius: '10px',
										backgroundColor: '#F9F9F9',
										paddingBottom: 1,
										padding: '14px',
									}}
								>
									<Typography
										sx={(theme) => ({
											fontSize: 14,
											fontFamily: 'Poppins',
											color: theme.palette.primary.darker_primary,
											fontWeight: 600,
											lineHeight: '150%',
										})}
									>
										{campaign?.name}
									</Typography>
									<Typography
										sx={(theme) => ({
											fontSize: 10,
											fontFamily: 'Poppins',
											color: theme.palette.primary.darker_primary,
											fontWeight: 400,
											lineHeight: '121%',
											mb: 1,
										})}
									>
										{moment(comment?.createdAt).format('MMMM D, YYYY')}
									</Typography>
									<Card sx={{ boxShadow: 'none', border: 'none', background: 'transparent', p: 0 }}>
										<Typography
											sx={{
												fontSize: 14,
												fontFamily: 'Poppins',
												color: AppColors.HEADING_TITLE2,
												fontWeight: 400,
												lineHeight: '121%',
												mb: 1,
											}}
										>
											{comment?.text}o
										</Typography>
									</Card>
								</Stack>
							))}
						</Stack>
						<Stack
							direction="column"
							gap={2}
							mt={2}
							px={1}
							py={1}
							sx={(theme) => ({
								background: theme.palette.primary.lightest_shade,
								borderRadius: '0 0 8px 8px',
								borderTop: '10px solid ',
								border: theme.palette.primary.light_shade,
							})}
						>
							{/* <Select
								className="custom-select"
								value={selectedCampaign}
								onChange={handleSelectCampaign}
								style={{
									width: '100%',
									backgroundColor: theme.palette.primary.lightest_shade,
									color: localSettingColors.fontColor,
								}}
								showSearch
								placeholder={<span style={{ color: localSettingColors.fontColor }}>Select a Campaign</span>}
								dropdownStyle={{
									backgroundColor: theme.palette.primary.lightest_shade,
								}}
								getPopupContainer={(triggerNode) => triggerNode.parentNode}
								filterOption={(input, option) => option.children.toLowerCase().includes(input.toLowerCase())}
							>
								{dummyCampaigns.map((option) => (
									<Select.Option key={option._id} value={option._id} item={option}>
										{option.basicDetails.name}
									</Select.Option>
								))}
							</Select> */}
							<Stack direction={'row'} gap={1} width="100%">
								<TextField
									value={text}
									onChange={(e) => setText(e.target.value)}
									placeholder="Type your message here"
									fullWidth
									size="small"
									sx={(theme) => ({
										'& .MuiOutlinedInput-root': {
											'& fieldset': {
												borderColor: theme.palette.primary.light_shade,
												borderRadius: '5px',
											},
											'&:hover fieldset': {
												borderColor: theme.palette.primary.light_shade,
											},
											'&.Mui-focused fieldset': {
												borderColor: theme.palette.primary.light_shade,
											},
										},
									})}
								/>
								<IconButton
									disabled={!text}
									onClick={handleSend}
									sx={(theme) => ({
										border: `1px solid`,
										borderRadius: '5px',
										background: theme.palette.primary.primary_shade,
										width: 40,
										height: 40,
										color: AppColors.WHITE,
										p: 0,
										'&.Mui-disabled': {
											background: theme.palette.primary.primary_shade,
											color: AppColors.WHITE,
											opacity: 1,
											border: `1px solid ${theme.palette.primary.light_shade}`,
										},
										'&:hover': {
											background: theme.palette.primary.primary_shade,
											color: AppColors.WHITE,
										},
									})}
								>
									<SendIcon color={AppColors.WHITE} />
								</IconButton>
							</Stack>
						</Stack>
					</Stack>
				</Stack>
			</Modal>
		</Stack>
	);
}
